import { createTheme } from '@mui/material/styles';
import { COLOR_PRIMARY } from 'src/const';

const theme = createTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
    },
  },
});

export default theme;
